<template>
  <v-data-table
    id="participants-table"
    :items="participants"
    :headers="headers.map(h => ({ ...h, text: h.text ? $t('EVENTFORM.tabs.participants.headers.' + h.text) : '' }))"
    :no-data-text="$t('EVENTFORM.tabs.participants.no_participants')"
    sort-by="name"
    :items-per-page="itemsPerPage"
    :hide-default-footer="participants.length <= itemsPerPage"
  >
    <template v-slot:[`header.actions`]="{ header }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            :disabled="!participants || participants.length === 0"
            @click="sendEmail(null)"
            style="font-size: 0.7rem"
          >
            <v-icon color="blue">{{ mdiEmailMultiple }}</v-icon>
          </v-btn>
        </template>
        <span>{{ header.text }}</span>
      </v-tooltip>
    </template>

    <template v-slot:[`item.presence`]="{ item }">
      <v-checkbox v-model="item.presence"></v-checkbox>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            @click="sendEmail(item)"
            v-on="on"
          >
            <v-icon>{{ mdiEmail }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('EVENTFORM.tabs.participants.send_email') }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
  import { mdiEmail, mdiEmailMultiple } from '@mdi/js';

  export default {
    name: 'ParticipantList',
    props: {
      participants: {
        type: Array,
        default: () => [],
        required: false
      }
    },
    data() {
      return {
        headers: [
          { text: 'name', value: 'name' },
          { text: 'email', value: 'email' },
          { text: 'presence', value: 'presence', sortable: false, align: 'center' },
          { text: 'send_email_to_all', value: 'actions', sortable: false, align: 'center' }
        ],
        itemsPerPage: 15,
        mdiEmail,
        mdiEmailMultiple
      }
    },
    methods: {
      sendEmail(user) {
        this.$emit('sendEmail', user);
      }
    }
  }
</script>

<style>
  #participants-table .v-input__control > .v-input__slot {
    align-items: center !important;
    justify-content: center !important;
  }

  #participants-table .v-input__control > .v-input__slot > .v-input--selection-controls__input {
    margin: 0;
  }
</style>
